module.exports = __webpack_public_path__ + "static/media/header-live-bg.c2729563.jpg";